
// import { useEffect, useState } from "react"

import {
    Container,
    Row
} from "reactstrap"

import { Route, Switch, useRouteMatch } from "react-router-dom"

import { useScenario } from "../../contexts/ScenarioContext"
// import { usePrefs }    from "../../contexts/PreferencesContext"

import {MDBNavBar} from "@meddbriefer/mdb-ui"

import Section from "../../routes/Section"

// import FindingsButton     from "../navbar/FindingsButton"
import SaveScenarioButton from "../navbar/SaveScenarioButton"
import ScenarioInfoButton from "../navbar/ScenarioInfoButton"
import Timer              from "../navbar/Timer"

// import PreferencesForm       from "../modals/PreferencesForm"z
// import FindingsModal         from "../modals/FindingsModal"
import ScenarioCompleteModal from "../modals/ScenarioCompleteModal"
import ScenarioDoneModal     from "../modals/ScenarioDoneModal"
import ScenarioInfo          from "../modals/ScenarioInfo"

import PhaseNavPane           from "../PhaseNavPane"
// import InterventionsPerformed from "../InterventionsPerformed"
import InterventionsList      from "../InterventionsList"
import IntvForm               from "../forms/IntvForm"

import IntvLayout        from "./IntvLayout"

import InterventionStatus      from "../InterventionStatus"
import Panel              from "../Panel"

export default function ScenarioLayout ({observer=null, next=null}) {
    const { path } = useRouteMatch()
    // const { showPrefsForm, hidePrefsForm } = usePrefs()
    const { currIntv, scenario } = useScenario()
    //showFindings, dismissFindings
    // const [form, setForm] = useState(null)

    const rightNav = (
        <>
            <SaveScenarioButton label={!next ? "Save" : "Done"} />
            <ScenarioInfoButton />
            {/* {"navbar" === patientStatusDisplay &&
                <FindingsButton />
            } */}
            <Timer />
        </>
    )

    return (
        <>
            <Container fluid className="main">
                <Row className="wrapper-row">
                    <nav className="col-md-2 phase-nav-pane">
                        <PhaseNavPane />
                    </nav>
                    <div className="col-md-10 main-region">
                        <div style={{ overflowY: "auto", maxHeight: "100%" }}>
                        <MDBNavBar
                            title={`SCENARIO: ${scenario.name}`}
                            rightNav={rightNav}
                            className="dev"
                        />
                        <main className="row main-row">
                            <div className="col-md-6 phase-col">
                                <Switch>
                                    <Route path={`${path}/:phaseID/:subPhaseID`} component={Section} />
                                    <Route path={`${path}/:phaseID`} component={Section} />
                                    <Route exact path={path} >
                                        <div></div>
                                    </Route>
                                </Switch>
                            </div>

                            <div className="col-md-6 interventions-col">
                            <IntvLayout
                                top={<div><InterventionsList />
                                    {!!currIntv && <IntvForm intvID={currIntv} /> } </div>}
                                bottom={
                                    <Panel title="Intervention Status" collapsable scrollBody>
                                    <InterventionStatus />
                                    </Panel>}
        />
                            </div>
                        </main>
                        </div>
                    </div>
                </Row>
            </Container>
            {/* <PreferencesForm show={showPrefsForm} dismiss={hidePrefsForm} /> */}
            <ScenarioInfo />
            {!next
                ? <ScenarioCompleteModal />
                : <ScenarioDoneModal observer={observer} next={next} />
            }
            {/* <FindingsModal show={showFindings} dismiss={dismissFindings} /> */}

        </>
    )
}

